// @flow
import React from 'react';
import Text from '@waglabs/text';

type Props = {
  children: any,
};

/**
 * Text component used when rendering any non-heading text. This is useful primarily because
 * this component contains default values for much of the text in our designs.
 *
 * @param {Node} children
 */
const WagText = ({
  children,
  ...rest
}: Props) => (
  <Text
    {...rest}
  >
    {children}
  </Text>
);

WagText.defaultProps = {
  fontSize: [1, 1, 2, 28],
  mt: 0,
  color: 'medGray',
  fontFamily: 'body',
};

export default WagText;
